(function () {
	var reveals = document.querySelectorAll(".hc-reveal");
	var staggers = document.querySelectorAll(".hc-reveal-stagger");
	if (!reveals.length && !staggers.length) return;

	var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	function revealAll(list) {
		list.forEach(function (el) {
			el.classList.add("is-visible");
		});
	}

	if (reduceMotion || !("IntersectionObserver" in window)) {
		revealAll(reveals);
		revealAll(staggers);
		return;
	}

	function observe(list, threshold) {
		if (!list.length) return;
		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						entry.target.classList.add("is-visible");
						observer.unobserve(entry.target);
					}
				});
			},
			{ threshold: threshold, rootMargin: "0px 0px -40px 0px" }
		);
		list.forEach(function (el) {
			observer.observe(el);
		});
	}

	// .hc-reveal-stagger wraps a variable-length list (e.g. a card grid) that
	// can be far taller than the viewport once stacked to a single mobile
	// column, so a percentage-of-self threshold like .hc-reveal uses may never
	// be reached until the user has scrolled well past the content - trigger
	// as soon as any part of it enters view instead.
	observe(reveals, 0.15);
	observe(staggers, 0);
})();
